import { defineComponent, onMounted, ref } from "vue";
import { ModalComponents, ModalStatus } from "@/constants/modal";
import { dialogVisibleForStatus } from "@/utils/vue-helpers/modal";
import i18n from "@/lang";
export default defineComponent({
  name: ModalComponents.PromocodeProcessing,
  setup: function setup() {
    var modalVisible = dialogVisibleForStatus(ModalStatus.PromocodeProcessing);
    var message = ref(i18n.global.t("promocode.processing-promocode"));
    onMounted(function () {
      // update message if syncing takes more than 10 seconds
      setTimeout(function () {
        message.value = i18n.global.t("promocode.taking-long");
      }, 10000);
    });
    return {
      modalVisible: modalVisible,
      message: message
    };
  }
});